<template>
  <!-- 成员 -->
  <div class="content">
    <van-list v-model="loading" :finished="finished" :finished-text="finishText" @load="handleGetPostList">
      <div class="list" v-if="list.length > 0">
        <div v-for="item in list" :key="item.id">
          <!-- 管理员 -->
          <div class="list_item">
            <div class="avatar">
              <img class="img"
                   :src="getAvator(item)"
                   alt=""/>
            </div>
            <div class="info">
              <div class="user">
                <div class="user_data">
                                    <span class="name">
                                        {{ item.userInfo && item.userInfo.realName }}
                                    </span>
                  <span class="user_type">
                                        {{ item && item.userCost }}分
                                    </span>
                </div>
              </div>
              <div class="hospital">
                {{ item.userInfo && item.userInfo.hospitalName }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="empty-block" v-else-if="isNone">
        <img src="@/assets/images/zone/img18.png" class="empty-img" alt=""/>
        <div class="empty-txt">暂无内容</div>
      </div>
    </van-list>
  </div>
</template>

<script>
import {costList} from '@/api/grade'
import {userAvatar} from '../data'

export default {
  props: {
    classId: ''
  },
  data() {
    return {
      list: [],
      loading: false,
      finished: false,
      pageObj: {
        pageNo: 1,
        pageSize: 10
      },
      searchContent: '',
      userAvatar,
      isNone: false,
      finishText: '没有更多了'
    }
  },
  computed: {
    userInfo() {
      return this.$store.getters.userInfo
    },
    getAvator() {
      return (item) => {
        if (item.userInfo && item.userInfo.headPicUrl) {
          return item.userInfo.headPicUrl
        }
        return userAvatar[item.roleType]
      }
    }
  },
  methods: {
    changeSwitchGroup(item, index) {
      this.list[index].isDropDown = !this.list[index].isDropDown
      this.$forceUpdate()
    },
    handleGo(item) {
      this.$router.push({
        path: '/studyReport',
        query: {
          iepOpenId: item.userInfo.iepOpenId,
          typeSource: 'grade'
        }
      })
    },
    handleGetPostList() {
      let params = {
        pageNum: this.pageObj.pageNo,
        pageSize: this.pageObj.pageSize,
        classId: this.classId
      }
      costList(params)
        .then(res => {
          this.$toast.clear()
          console.log(res, '23')
          if (res) {
            if (res.code !== 0 || !res.data) {
              this.loading = false
              this.finished = true
              return false
            }

            this.loading = false
            if (res.data.list.length < this.pageObj.pageSize) {
              this.finished = true
            }
            if (res.code === 0 && res.data.list) {
              this.list = this.list.concat(res.data.list)
            }
            this.pageObj.pageNo++
            if (this.list.length === 0) {
              this.isNone = true
              this.finishText = ''
            }
          }
        })
        .catch(err => {
          this.$toast.clear()
          console.log('err:', err)
        })
    }
  }
}
</script>

<style scoped lang="less">
.content {
  // height: 100%;
  min-height: calc(100vh - 214px);
  background: linear-gradient(180deg, #f6f8fa 6%, #edf1f4 8%, #f2f7fa 100%);
}

.list {
  padding: 10px 16px;
  box-sizing: border-box;
  background: linear-gradient(180deg,
  #f6f8fa 0%,
  #f6f8fa 6%,
  #f6f8fa 8%,
  #f6f8fa 100%);

  .list_item {
    width: 343px;
    // min-height: 74px;
    margin-bottom: 8px;
    background-color: #fff;
    border-radius: 12px;
    padding: 14px 10px;
    box-sizing: border-box;
    display: flex;
    align-items: center;

    .group-box {
      width: 100%;

      .group-item {
        display: flex;
        align-items: center;
        height: 62px;
        padding: 0 10px;
      }

      .border {
        border-bottom: 1px solid #e6ebee;
      }

      .group-menu {
        padding: 10px 7px;

        .list_item {
          background: #f0f5f8 !important;
          width: 100%;

          &:last-child {
            margin-bottom: 0;
          }
        }
      }
    }

    .avatar {
      width: 42px;
      min-width: 42px;
      height: 42px;
      margin-right: 6px;
      border-radius: 50%;
      overflow: hidden;

      .img {
        width: 42px;
        min-width: 42px;
        height: 42px;
      }
    }

    .info {
      width: 260px;

      .user {
        display: flex;
        justify-content: space-between;
        margin-bottom: 8px;
        align-items: center;

        .user_data {
          display: flex;
          align-items: center;
          justify-content: space-between;
          overflow: hidden;
          flex: 1;

          .name {
            margin-right: 4px;
            font-family: Source Han Sans CN, Source Han Sans CN;
            font-weight: 400;
            font-size: 14px;
            color: #000000;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }

          .user_type {
            color: #EB1700;
            font-size: 14px;
            font-weight: 400;
          }
        }

        .acenter {
          align-items: center;
        }

        .study_report {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 82px;
          height: 24px;
          background: rgba(235, 23, 0, 0.1);
          border-radius: 22px 22px 22px 22px;

          .report-title {
            font-weight: 400;
            font-size: 14px;
            color: #eb1700;
          }

          .study-right {
            background: url("../../../assets/images/grade/study-right.png") no-repeat center center / 100% 100%;
            width: 6px;
            height: 10px;
            margin-left: 4px;
          }
        }

        .drop-down {
          .icon-drop {
            width: 13px;
            height: 8px;
          }
        }

        .time {
          font-family: Source Han Sans CN, Source Han Sans CN;
          font-weight: 400;
          font-size: 12px;
          color: #7a8494;
        }
      }

      .user-no {
        margin-bottom: 0;
      }

      .hospital {
        font-family: Source Han Sans CN, Source Han Sans CN;
        font-weight: 500;
        font-size: 14px;
        color: #7a8494;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }
  }

  .gruop-menu {
    padding: 0;
    // box-shadow: 0px 2px 8px 0px rgba(0,0,0,0.06);
  }
}

.empty-block {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding-top: 60px;

  .empty-img {
    width: 185px;
    display: block;
    margin-bottom: 4px;
  }

  .empty-txt {
    font-size: 12px;
    color: #949ba5;
    text-align: center;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/grade/components/ranking.vue